/**
history-map-legend
*/


<template>
    <div class="history-map-legend">
        <div class="history-map-legend-item" v-for="(item, key) in legendItems" v-if="selectedItems.includes(key)">
            <img alt="" v-bind:src="item[1]"/>
            <span>{{ item[0] }}</span>
        </div>
    </div>
</template>


<script>


export default {
    name: "history-map-legend",
    components: {},
    props: {
        selectedItems: {type: Array, required: true}
    },
    data: function () {
        return {
            legendItems: {
                "mczs-active": ["MCZs", "/static/img/history-legend-mczs-active.png", "Marine Conservation Zone (MCZ)"],
                "mczs-faded": ["MCZs", "/static/img/history-legend-mczs-faded.png", "Marine Conservation Zone (MCZ)"],
                "sacs-active": ["SACs", "/static/img/history-legend-sacs-active.png", "Special Area of Conservation (SAC)"],
                "sacs-faded": ["SACs", "/static/img/history-legend-sacs-faded.png", "Special Area of Conservation (SAC)"],
                "spas-active": ["SPAs", "/static/img/history-legend-spas-active.png", "Special Protection Area (SPA)"],
                "spas-faded": ["SPAs", "/static/img/history-legend-spas-faded.png", "Special Protection Area (SPA)"],
                "ncmpas-active": ["NCMPAs", "/static/img/history-legend-ncmpas-active.png", "Nature Conservation MPA (NCMPA)"],
                "ncmpas-faded": ["NCMPAs", "/static/img/history-legend-ncmpas-faded.png", "Nature Conservation MPA (NCMPA)"]
            }
        }
    },
    methods: {},
    computed: {},
    watch: {},
    mounted: function () {
    }
}
</script>


<style lang="scss">
    @import "../../../styles/variables.scss";

    .history-map-legend {
        @media screen and (min-width: 1141px) {
            position: absolute;
            z-index: 1000;
            top: 10px;
            left: 30px;

            padding: 5px 8px 8px 8px;
            border: 1px solid $mcs-green-highlight;
            background-color: white;
            border-radius: 5px;
        }

        @media screen and (max-width: 1140px) {
            max-width: 840px;
            margin: 3px auto 0 auto;
            //margin: 5px 8px 0 8px;
        }
        @media screen and (max-width: 855px) {
            max-width: 840px;
            //margin: 3px auto 0 auto;
            margin: 5px 8px 0 8px;
        }
    }

    .history-map-legend-item {
        font-size: 90%;

        img {
            width: 18px; height: 18px;
            vertical-align: middle;
            margin-right: 5px;
        }

        span {
            //line-height: 20px;
        }

        @media screen and (max-width: 1140px) {
            display: inline-block;
            margin: 0 5px 5px 0;
        }
    }
</style>